import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const cls = "group fly-card p-6 flex items-start gap-5 rise transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-0.5 hover:border-blue-500/60 hover:shadow-[0_0_24px_rgba(37,99,235,0.25)]";

export const HomeTile = ({ t, i, className = "" }) => {
  const body = (
    <>
      <div className="h-12 w-12 shrink-0 rounded-xl bg-blue-600/15 border border-blue-500/30 flex items-center justify-center">
        <t.icon className={`w-6 h-6 ${t.iconColor || "text-blue-400"}`} />
      </div>
      <div className="flex-1 self-center">
        <div className={`font-display text-2xl font-bold uppercase tracking-wide ${t.color || ""}`}>{t.title}</div>
        {t.desc && <p className="text-sm text-slate-400 mt-1">{t.desc}</p>}
        {t.extra}
      </div>
      <ArrowUpRight className="w-5 h-5 text-slate-500 group-hover:text-blue-400 transition-colors" />
    </>
  );
  const style = { animationDelay: `${160 + i * 80}ms` };
  if (t.href) {
    return <a href={t.href} target="_blank" rel="noopener noreferrer" data-testid={t.id} className={`${cls} ${className}`} style={style}>{body}</a>;
  }
  return <Link to={t.to} data-testid={t.id} className={`${cls} ${className}`} style={style}>{body}</Link>;
};
